<template>
  <div class="lxm-contact">
    <transition :name="transitionName" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/variables.styl'
</style>

<script>
  export default {
    computed: {
      transitionName () {
        return this.$store.getters.transitionName
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?1bfe3d05